import { render, staticRenderFns } from "./ApplePay.vue?vue&type=template&id=0f0ad7d2"
import script from "./ApplePay.vue?vue&type=script&lang=js"
export * from "./ApplePay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports